import { useEffect, useState } from 'react';
import { ShopListItem } from '~/components/ui/ShopListItem';
import { rage, TattooItemConfig } from '~/rage';
import { TattooCategory, WalletType } from '~/shared';

const ListTabItem = ({
	item,
	index,
	activeCategory,
	activeListIndex,
	handleSelect,
	tattooDeletionPrice,
	ownedTattoos,
}: {
	item: TattooItemConfig;
	index: number;
	activeCategory: TattooCategory | 'delete';
	activeListIndex: number | null;
	handleSelect: (index: number) => void;
	tattooDeletionPrice: number;
	ownedTattoos: TattooItemConfig[] | null;
}) => {
	const seenTrackerKey = `${activeCategory}.${item.id}`;
	const [isUnseen, setIsUnseen] = useState(
		activeCategory !== 'delete' && rage.tattooShop.isUnseen(seenTrackerKey),
	);

	useEffect(() => {
		if (index === activeListIndex && activeCategory !== 'delete') {
			const seenTrackerKey = `${activeCategory}.${item.id}`;
			rage.tattooShop.markSeen(seenTrackerKey);
			setIsUnseen(false);
		}
	}, [index, activeListIndex, activeCategory, item.id]);

	const isInstalled =
		activeCategory !== 'delete' &&
		ownedTattoos?.some((tattoo) => tattoo.id === item.id);

	return (
		<ShopListItem
			title={item.name}
			price={
				activeCategory === 'delete' ? tattooDeletionPrice : item.price ?? 0
			}
			walletType={WalletType.Cash}
			id={`tattoo-${item.id}`}
			handleClick={() => handleSelect(index)}
			active={index === activeListIndex}
			installed={isInstalled}
			isNew={isUnseen}
			key={index}
		/>
	);
};

export { ListTabItem };
